// extracted by mini-css-extract-plugin
module.exports = {"el":"LottieAnimation_el__WM3bu","visible":"LottieAnimation_visible__p6OFs"};